/*
  $( document ).ready(function() {
  console.log("shipping timer js loaded!")
  later.date.localTime();
  function addWeekDays(includeWeekends, initialDate, weekdaysToAdd){
    weekDaysAdded = 0;
    currentDay = moment(initialDate)
    while (weekDaysAdded < weekdaysToAdd){
      currentDay = currentDay.add(1, 'days')
      weekday = currentDay.format('dddd'); // Monday ... Sunday
      isWeekend = weekday === 'Sunday' || weekday === 'Saturday';
      if ( !isWeekend || includeWeekends ) { // add day if its not a weekend, or if include weekends is true
        weekDaysAdded += 1;
      }
    }
    return currentDay;
  }

  $(".shipping-option").each( function(){
    wrapper = $(this)
    country_codes = wrapper.attr("country_codes");
//     if ( country_codes ){
//       split_country_codes = country_codes.split(",").map(function(country_code){ return country_code.trim() });
//       console.log("split_codes are", split_country_codes);
//       currentCurrencyCode = Cookies.get('cart_currency');
//       // IF currency currency code is in the accepted currency codes then leave it, if its not then hide it
//       if (split_country_codes.indexOf(currentCurrencyCode) > -1) {
//         //Should be shown
//       } else {
//         //Should not be shown
//         $(this).hide()
//       }
//     }


    use_cutoff_date = wrapper.attr("use_cutoff_date") == "true" ? true : false;
    cutoff_date = wrapper.attr("cutoff_date");
    cutoff_time = wrapper.attr("cutoff_time");
    console.log("cutoff_time", cutoff_time)
    use_weekend_delivery = wrapper.attr("use_weekend_delivery") == "true" ? true : false;

    min_delivery_delay = wrapper.attr("min_delivery_delay");
    max_delivery_delay = wrapper.attr("max_delivery_delay");
    shipping_text = wrapper.find(".shipping-option-text")
    countdown_text = shipping_text.children(".shipping-option-countdown");
    recieve_on_text = shipping_text.children(".shipping-option-date");
    //console.log(cutoff_time, min_delivery_delay, max_delivery_delay, shipping_text, countdown_text, recieve_on_text)

    //Get todays date at XX:XX 1-5 means weekdays
    //Splitting date by : and reversing it then joining it by ' ' because cron syntax is (MM HH) DM MM DW
    splitReverseTime = cutoff_time.split(":").reverse().join(" ")
    //splitReverseTime = cutoff_time.split(":").reverse().join(" ")
    //alert(splitReverseTime);
    cutoff_cron_date = use_cutoff_date ? cutoff_date : "1-5"; //if use a cutoff date then use that but if not just use weekdays
    console.log("cutoff cron date", cutoff_cron_date);
    cronExpression = splitReverseTime + " * * " + cutoff_cron_date;
    orderByCron = later.parse.cron(cronExpression);
    nextCutOffDate  = later.schedule(orderByCron).next(); //finding the next order by date with cron
    console.log("nextCutOffDate", nextCutOffDate)

    //Make Countdown Countdown to cutff Date
    countdown_text.countdown(nextCutOffDate)
      .on('update.countdown', function(event) {
        //Format cutoff date and add format for days if there are days
        console.log(event)
        if(event.offset.days > 0) {
          // If offset hours are large show the moment calendar date e.g. tomorrow at 3pm
          formattedFinalDate = moment(event.finalDate).format("LT dddd Do")
          $(this).text("by " + formattedFinalDate);
        }else {
          // if there are a small number of hours left till countdown date show x hours y minutesor y minutes
          format = event.offset.hours > 0 ? '%-H hrs %-M mins' : '%-M mins';
          $(this).text("within " + event.strftime(format));
        }
      })
    //Format recieve on text with weekdays in the future starting at the next cutoff point
    dateFormat = "MMM Do"
    if (min_delivery_delay != max_delivery_delay) {
      recieve_on_string = addWeekDays(use_weekend_delivery, nextCutOffDate, min_delivery_delay).format(dateFormat) + " - " + addWeekDays(use_weekend_delivery, nextCutOffDate, max_delivery_delay).format(dateFormat)
    }else{
      recieve_on_string = addWeekDays(use_weekend_delivery, nextCutOffDate, min_delivery_delay).format(dateFormat);
    }
    //console.log("string:", recieve_on_string)
    recieve_on_text.text(recieve_on_string);
  });
});
*/


$(document).ready(function() {
  console.log("shipping timer js loaded!");
  later.date.localTime();

  function addWeekDays(includeWeekends, initialDate, weekdaysToAdd) {
    let weekDaysAdded = 0;
    let currentDay = moment(initialDate);
    while (weekDaysAdded < weekdaysToAdd) {
      currentDay = currentDay.add(1, 'days');
      let weekday = currentDay.format('dddd'); // Monday ... Sunday
      let isWeekend = weekday === 'Sunday' || weekday === 'Saturday';
      if (!isWeekend || includeWeekends) { // add day if its not a weekend, or if include weekends is true
        weekDaysAdded += 1;
      }
    }
    return currentDay;
  }

  $(".shipping-option").each(function() {
    let wrapper = $(this);
    let country_codes = wrapper.attr("country_codes");

    // Uncomment and modify the following lines if you need to handle country codes
    // if (country_codes) {
    //   let split_country_codes = country_codes.split(",").map(function(country_code) { return country_code.trim(); });
    //   console.log("split_codes are", split_country_codes);
    //   let currentCurrencyCode = Cookies.get('cart_currency');
    //   // IF currency currency code is in the accepted currency codes then leave it, if its not then hide it
    //   if (split_country_codes.indexOf(currentCurrencyCode) > -1) {
    //     //Should be shown
    //   } else {
    //     //Should not be shown
    //     $(this).hide();
    //   }
    // }

    let use_cutoff_date = wrapper.attr("use_cutoff_date") === "true";
    let cutoff_date = wrapper.attr("cutoff_date");
    let cutoff_time = wrapper.attr("cutoff_time");
    let use_weekend_delivery = wrapper.attr("use_weekend_delivery") === "true";

    let min_delivery_delay = wrapper.attr("min_delivery_delay");
    let max_delivery_delay = wrapper.attr("max_delivery_delay");
    let shipping_text = wrapper.find(".shipping-option-text");
    let countdown_text = shipping_text.children(".shipping-option-countdown");
    let recieve_on_text = shipping_text.children(".shipping-option-date");

    // Get the user's selected language from a cookie (or another source)
    // let userLanguage = $('html').attr('lang'); // default to 'en' if no cookie is found
    // console.log(userLanguage)
    // moment.locale(userLanguage);

    // Get today's date at XX:XX 1-5 means weekdays
    let splitReverseTime = cutoff_time.split(":").reverse().join(" ");
    let cutoff_cron_date = use_cutoff_date ? cutoff_date : "1-5"; // if use a cutoff date then use that but if not just use weekdays
    console.log("cutoff cron date", cutoff_cron_date);
    let cronExpression = splitReverseTime + " * * " + cutoff_cron_date;
    let orderByCron = later.parse.cron(cronExpression);
    let nextCutOffDate = later.schedule(orderByCron).next(); // finding the next order by date with cron
    console.log("nextCutOffDate", nextCutOffDate);

    // Make Countdown Countdown to cutoff Date
    countdown_text.countdown(nextCutOffDate)
      .on('update.countdown', function(event) {
        // Format cutoff date and add format for days if there are days
        console.log(event);
        if (event.offset.days > 0) {
          // If offset hours are large show the moment calendar date e.g. tomorrow at 3pm
          let formattedFinalDate = moment(event.finalDate).format("LT dddd Do");
          $(this).text("by " + formattedFinalDate);
        } else {
          // if there are a small number of hours left till countdown date show x hours y minutes or y minutes
          let format = event.offset.hours > 0 ? '%-H hrs %-M mins' : '%-M mins';
          $(this).text("within " + event.strftime(format));
        }
      });

    // Format recieve on text with weekdays in the future starting at the next cutoff point
    let dateFormat = "MMM Do";
    let recieve_on_string;
    if (min_delivery_delay != max_delivery_delay) {
      recieve_on_string = addWeekDays(use_weekend_delivery, nextCutOffDate, min_delivery_delay).format(dateFormat) + " - " + addWeekDays(use_weekend_delivery, nextCutOffDate, max_delivery_delay).format(dateFormat);
    } else {
      recieve_on_string = addWeekDays(use_weekend_delivery, nextCutOffDate, min_delivery_delay).format(dateFormat);
    }
    recieve_on_text.text(recieve_on_string);

let userLanguage = $('html').attr('lang');
if(userLanguage == 'fr'){
let monthMap = {
  'Jan': 'Janv',
  'Feb': 'Févr',
  'Mar': 'Mars',
  'Apr': 'Avr',
  'May': 'Mai',
  'Jun': 'Juin',
  'Jul': 'Juil',
  'Aug': 'Août',
  'Sep': 'Sept',
  'Oct': 'Oct',
  'Nov': 'Nov',
  'Dec': 'Déc'
};


function convertDateRangeToFrench(dateRange) {
  const [startDate, endDate] = dateRange.split(' - ');
  
  const [startMonth, startDay] = startDate.split(' ');
  const [endMonth, endDay] = endDate.split(' ');

  const cleanStartDay = startDay.replace(/(st|nd|rd|th)/, '');
  const cleanEndDay = endDay.replace(/(st|nd|rd|th)/, '');

  const frenchStartMonth = monthMap[startMonth];
  const frenchEndMonth = monthMap[endMonth];

  return `${frenchStartMonth} ${cleanStartDay} - ${frenchEndMonth} ${cleanEndDay}`;
}

const englishDateRange = recieve_on_string;
const frenchDateRange = convertDateRangeToFrench(englishDateRange);

    recieve_on_text.text(frenchDateRange);

}else{
  recieve_on_text.text(recieve_on_string);
}
  });
});
